export const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*)@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]+)\])/;

export const safetyUrl = "botwise.io";

export const sanitizeHtmlAllowedTags = ["b", "i", "strong", "br", "ul", "li", "ol"];

export const PAGE = {
	INDEX: "index",
	REPORT: "report",
	PRIVACY: "privacy",
	PRODUCT: "product",
	TERMS: "terms",
	FUNDS: "funds",
};

export const YOUTUBE_PROMO_URL = "Rnum4F9_Or0";
